// Per-locale formatting rules:
// - fr-*  : space as thousand separator, symbol after the number   -> "1 000€"
// - nl-*  : dot as thousand separator,   symbol before the number  -> "€1.000"
// - en-GB : comma as thousand separator, symbol before the number  -> "£1,000"
// - en-US : kept on £ for backwards compatibility with previous behaviour
const localeConfig = {
	"fr-FR": { intl: "fr-FR", symbol: "€", position: "after" },
	"fr-FR-CSE": { intl: "fr-FR", symbol: "€", position: "after" },
	"fr-CH": { intl: "fr-FR", symbol: "€", position: "after" },
	"fr-BE": { intl: "fr-FR", symbol: "€", position: "after" },
	"nl-BE": { intl: "nl-BE", symbol: "€", position: "before" },
	"nl-NL": { intl: "nl-NL", symbol: "€", position: "before" },
	"en-GB": { intl: "en-GB", symbol: "£", position: "before" },
	"en-US": { intl: "en-GB", symbol: "£", position: "before" },
};

const normalizeLocale = (locale) => (locale || "").replace(/_/g, "-");

const formatNumber = (value, intlLocale, toFixed) => {
	const formatter = new Intl.NumberFormat(intlLocale, {
		useGrouping: true,
		minimumFractionDigits: toFixed,
		maximumFractionDigits: toFixed,
	});
	// Intl outputs U+202F (narrow no-break space) / U+00A0 (no-break space)
	// for fr-* locales; normalize to a regular space for consistent rendering.
	return formatter.format(value).replace(/[\u202F\u00A0]/g, " ");
};

/**
 * Format a price for display.
 * `price` is in cents (euros * 100). Calculations should keep WIYP's 2-decimal
 * values; this helper ceils to a whole unit when `toFixed` is 0.
 */
export default (price, locale, toFixed = 0) => {
	const config = localeConfig[normalizeLocale(locale)];
	if (!config) return null;

	const cents = Math.round(Number(price));
	if (!Number.isFinite(cents)) return null;

	const euros = cents / 100;
	const absEuros = Math.abs(euros);
	// Ceil whole-unit display (443.9 → 444). Keep 2-decimal values when toFixed > 0 (fees).
	const value = toFixed === 0 ? Math.ceil(absEuros) : absEuros;
	if (!Number.isFinite(value)) return null;

	const fractionDigits = toFixed === 0 || Number.isInteger(value) ? 0 : toFixed;
	const formatted = formatNumber(value, config.intl, fractionDigits);
	const sign = euros < 0 ? "-" : "";

	return config.position === "after"
		? `${sign}${formatted}${config.symbol}`
		: `${sign}${config.symbol}${formatted}`;
};
